import debounce from '@/assets/scripts/utils/debounce';
document.querySelectorAll('.selected-works-section').forEach((section) => {
    const photos = section.querySelectorAll('.project-card__photo');
    const updateHeights = () => {
        if (photos.length >= 4) {
            const baseHeight = photos[0].offsetHeight;
            photos[1].style.height = `${baseHeight}px`;
            photos[2].style.height = `${baseHeight}px`;
        }
    };
    const handleResize = () => {
        updateHeights();
    };
    updateHeights();
    window.addEventListener("resize", debounce(handleResize, 150));
});
